import React, { useRef, useState, useCallback, useEffect } from 'react';
import styles from './index.module.scss';
import { useScreenSlideIn } from '@/hooks/useScreenSlideIn';
import imgPic1 from '@/assets/home/screen-news/pic-1.png';
import imgPic2 from '@/assets/home/screen-news/pic-2.png';
import imgPic3 from '@/assets/home/screen-news/pic-3.png';
import imgPic4 from '@/assets/home/screen-news/pic-4.png';
import imgPic5 from '@/assets/home/screen-news/pic-5.png';
import imgPic6 from '@/assets/home/screen-news/pic-6.png';
import imgPic7 from '@/assets/home/screen-news/pic-7.png';
import imgPic8 from '@/assets/home/screen-news/pic-8.png';
import imgPic9 from '@/assets/home/screen-news/pic-9.png';
import imgPic10 from '@/assets/home/screen-news/pic-10.png';
import imgPic11 from '@/assets/home/screen-news/pic-11.png';
import imgPic12 from '@/assets/home/screen-news/pic-12.png';
import imgPic13 from '@/assets/home/screen-news/pic-13.png';
import imgPic14 from '@/assets/home/screen-news/pic-14.png';
import imgPic15 from '@/assets/home/screen-news/pic-15.png';
import imgPic16 from '@/assets/home/screen-news/pic-16.png';
import imgIcon1 from '@/assets/home/screen-news/icon-1.png';
import imgIcon2 from '@/assets/home/screen-news/icon-2.png';
import imgIcon3 from '@/assets/home/screen-news/icon-3.png';
import imgIcon4 from '@/assets/home/screen-news/icon-4.png';
import imgIcon6 from '@/assets/home/screen-news/icon-6.png';
import imgIcon7 from '@/assets/home/screen-news/icon-7.png';
import imgIcon8 from '@/assets/home/screen-news/icon-8.png';
import imgIcon9 from '@/assets/home/screen-news/icon-9.png';
import imgIcon10 from '@/assets/home/screen-news/icon-10.png';
import imgIcon12 from '@/assets/home/screen-news/icon-12.png';
import imgIcon13 from '@/assets/home/screen-news/icon-13.png';
import imgIcon14 from '@/assets/home/screen-news/icon-14.png';
import iconRight from '@/assets/home/screen-news/arrow-right.png';
import CircleArrowButton from '@/components/CircleArrowButton';

interface CarouselItem {
  id: number;
  titleLines: [string, string];
  text: string;
  pic: string;
  icon: string;
  iconHeight?: number;
  url: string;
}

const carouselItems: CarouselItem[] = [
  {
    id: 0,
    titleLines: ['人民日报：', '数字人技术亮相《2025开学第一课》'],
    text: '9月1日，在《2025开学第一课》的舞台上，一个跨越时空的敬礼，震撼了全国观众——左权将军以数字人形象“复活”，目光坚毅，身姿挺拔……',
    pic: imgPic1,
    icon: imgIcon1,
    url: 'https://www.peopleapp.com/column/30050149452-500007066548',
  },
  {
    id: 1,
    titleLines: ['中国日报：2025世界人工智能大会', '与爱为舞创始人分享AI应用创业的思考与实践'],
    text: '在2025世界人工智能大会（WAIC 2025）期间，人工智能正以前所未有的深度和广度重塑产业生态。7月28日上午，启明创投主办的……',
    pic: imgPic2,
    icon: imgIcon2,
    url: 'https://cn.chinadaily.com.cn/a/202507/28/WS68873582a310a07bb590a9a0.html',
  },
  {
    id: 2,
    titleLines: ['新华社：行业首个AI“一对一”落地一年', '与爱为舞收获百万级学员体验'],
    text: '近日，AI原生应用企业与爱为舞对外发布首个AI“一对一”导师落地近一年“成绩单”。数据显示，真人级AI导师教出的首批AI学习“原住民”规模已达百万级……',
    pic: imgPic3,
    icon: imgIcon3,
    iconHeight: 28,
    url: 'https://h.xinhuaxmt.com/vh512/share/12899821',
  },
  {
    id: 3,
    titleLines: ['新华网：AI数字人技术取得突破性进展', '与爱为舞发布实时语音驱动框架'],
    text: '近日，我国人工智能应用企业“与爱为舞”研发团队在数字人技术领域取得重要突破，自主研发实时音视频同步动画生成系统……',
    pic: imgPic4,
    icon: imgIcon4,
    iconHeight: 28,
    url: 'https://www.xinhuanet.com/tech/20250917/8a47762c73054c3c80ff9176c8a47bc1/c.html',
  },
  {
    id: 4,
    titleLines: ['新华网：与爱为舞张怀亭：生成式AI破题', '“规模化因材施教”'],
    text: '新华网海南博鳌12月5日电（王岩）12月4日，以“AI赋能·智领新质”为主题的2025数智科技创新发展大会在海南博鳌召开……',
    pic: imgPic5,
    icon: imgIcon4,
    iconHeight: 28,
    url: 'https://www.news.cn/enterprise/20251223/b9bde90fc1d443c1aa1066683a621c49/c.html',
  },
  {
    id: 5,
    titleLines: ['国家发展改革委培训中心（宣传中心）赴北京与爱为舞科技有限公司调研', ''],
    text: '为深入贯彻落实全国两会关于“打造智能经济新形态”，深化拓展“人工智能＋”的重要部署，按照国家发展改革委培训中心（宣传中心）“春耕行动”主题调研计划安排......',
    pic: imgPic16,
    icon: imgIcon13,
    url: 'https://mp.weixin.qq.com/s/PVHqo3GFsRArq5tdDww2-g',
  },
  {
    id: 14,
    titleLines: ['爱学：', '海淀区领导调研北京与爱为舞科技有限公司'],
    text: '12月23日，区委书记张革到北京与爱为舞科技有限公司开展调研，了解企业在海淀成长感受及发展诉求，倾听对优化营商环境相关建议，进一步坚定企业扎根海淀发展信心......',
    pic: imgPic15,
    icon: imgIcon14,
    url: 'https://mp.weixin.qq.com/s/mvWcTNp6ME5jn0lIbk8qLQ',
  },
  {
    id: 6,
    titleLines: ['36氪：', '第一批AI原生应用企业，交卷'],
    text: '当大多数企业还在摸索如何“用AI”，这个时代最激进的一批探路者，已经在回答一个终极问题：当一家公司“生而AI”，底层架构和运行逻辑完全建立在AI之上，会发生什么……',
    pic: imgPic6,
    icon: imgIcon6,
    iconHeight: 28,
    url: 'https://mp.weixin.qq.com/s/1N6QC-5dVHdC50LpaOer3w?scene=1&click_id=29',
  },
  {
    id: 7,
    titleLines: ['极客公园：AI 应用首次实现万人互动共学', '与爱为舞重构 AI 教育范式'],
    text: '当大多数 AI 教育产品还在纠结于「像不像真人」、「超越真人」时，与爱为舞已经实现了 AI 导师的规模化服务……',
    pic: imgPic7,
    icon: imgIcon7,
    url: 'https://www.geekpark.net/news/356798',
  },
  {
    id: 8,
    titleLines: ['三联生活周刊：', 'AI时代的第一批原住民: 10后正在怎样长大？'],
    text: '加州硅谷，从未写过一行代码的8岁男孩，仅凭AI助手，用两小时开发出一款新游戏；北京，三年级男孩在AI辅助下完成了一本小说，登上热搜……',
    pic: imgPic8,
    icon: imgIcon8,
    iconHeight: 28,
    url: 'https://mp.weixin.qq.com/s/-H3ZJmJJnQyqPaLz-vjPbA',
  },
  {
    id: 9,
    titleLines: ['机器之心：上线不到一年，收徒百万', '首个真人级AI导师技术底牌首次曝光'],
    text: '第一次见到「爱学」前，王佳佳（化名）害怕和老师互动。这个来自安徽阜阳的初三女生，性格内向，在课堂上几乎从不举手……',
    pic: imgPic9,
    icon: imgIcon9,
    url: 'https://mp.weixin.qq.com/s/eNVVbsrzHfgscRRhq57yPQ',
  },
  {
    id: 10,
    titleLines: ['量子位：千人千面的真人级AI名师', '劈开教育「不可能三角」'],
    text: '这位AI导师，出自一家名为「与爱为舞」的AI原生应用企业。自年初上线以来，已累计为百万级用户提供学习陪伴与一对一讲解服务……',
    pic: imgPic10,
    icon: imgIcon10,
    url: 'https://mp.weixin.qq.com/s/LtyEyZNsZvur8u-o2MSNpw',
  },
  {
    id: 11,
    titleLines: ['新华网：人机协同重塑教学生态', '从“数字人苏轼”入课看与爱为舞的AI教育实践'],
    text: '近日，在北京市海淀区人北实验学校的一堂AI公开课上，千年文豪苏轼“跨越时空”出现在大屏幕上，与六年级学生共同探讨经典名篇《书戴嵩画牛》……',
    pic: imgPic11,
    icon: imgIcon4,
    iconHeight: 28,
    url: 'https://www.xinhuanet.com/tech/20251222/c283fdd371e5420da0603e2d0975ceea/c.html',
  },
  {
    id: 12,
    titleLines: ['芥末堆：真正的AI导师来了！', '与爱为舞发布首款AI产品'],
    text: '10月24日，与爱为舞正式发布首款AI产品——爱学，定位为一款面向全龄人群的终身教育平台。据介绍，“爱学”旨在打造AI一对一教育新范式，营造一个“人人皆学、处处能学、时时可学”的智能学习生......',
    pic: imgPic13,
    icon: imgIcon12,
    url: 'https://mp.weixin.qq.com/s/Ob_L1ch92118CyzqAGPf8g',
  },
  {
    id: 13,
    titleLines: ['芥末堆：【GET2025】与爱为舞王琳', '爱与AI帮助每个人成为更好的自己'],
    text: '11月17日至18日，芥末堆在北京举办以“教育有AI，学习无界”为主题的GET2025教育科技大会。与爱为舞联合创始人王琳就《从单向输出，到万人互动—“爱学”的AI落地实践》进行了主题分.....',
    pic: imgPic14,
    icon: imgIcon12,
    url: 'https://mp.weixin.qq.com/s/Yms3UAJkAI9O09Odp1Ml4Q',
  },
  {
    id: 15,
    titleLines: ['芥末堆：百万学员之后', '爱学AI学习智能体完成低龄段全场景覆盖'],
    text: '今年两会审议的“十五五”规划纲要中明确提出“促进人工智能助力教育模式变革”。这是国家层面第一次把人工智能与教育模式变革直接绑定……',
    pic: imgPic12,
    icon: imgIcon12,
    url: 'https://mp.weixin.qq.com/s/BX4cxGAqwZep6-V1jqItlg',
  },
];

const SLOT_WIDTH = 362;
const ITEM_WIDTH = 346;
const TRACK_GAP = 16;

/** 不足 3 条时按顺序循环补齐，保证视口内始终可展示 3 张 */
function padCarouselToThree(items: CarouselItem[]): CarouselItem[] {
  if (items.length === 0) return [];
  if (items.length >= 3) return items;
  return Array.from({ length: 3 }, (_, i) => items[i % items.length]);
}

const screenNewsItems = padCarouselToThree(carouselItems);
const screenNewsCount = screenNewsItems.length;
const trackOrder =
  screenNewsCount > 0
    ? [...screenNewsItems, ...screenNewsItems, ...screenNewsItems]
    : [];

function trackWidthPx(length: number) {
  if (length <= 0) return 0;
  return length * ITEM_WIDTH + (length - 1) * TRACK_GAP;
}

export default function ScreenNews() {
  const slideInRef = useScreenSlideIn({
    triggerSlideRatio: 0.8,
    animationClassName: styles['screen-news-anim-start'],
  });
  const trackRef = useRef<HTMLDivElement>(null);
  const carouselRef = useRef<HTMLDivElement>(null);
  const [slideIndex, setSlideIndex] = useState(screenNewsCount);
  const isTransitioning = useRef(false);

  const goNext = useCallback(() => {
    if (isTransitioning.current || screenNewsCount === 0) return;
    isTransitioning.current = true;
    setSlideIndex((prev) => prev + 3);
  }, []);

  const goPrev = useCallback(() => {
    if (isTransitioning.current || screenNewsCount === 0) return;
    isTransitioning.current = true;
    setSlideIndex((prev) => prev - 3);
  }, []);

  const handleTrackTransitionEnd = useCallback(
    (e: React.TransitionEvent) => {
      if (e.target !== trackRef.current || e.propertyName !== 'transform') return;
      const track = trackRef.current;
      if (!track || screenNewsCount === 0) return;
      if (slideIndex >= 2 * screenNewsCount) {
        track.style.transition = 'none';
        setSlideIndex(slideIndex - screenNewsCount);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            track.style.transition = '';
            isTransitioning.current = false;
          });
        });
      } else if (slideIndex < screenNewsCount) {
        track.style.transition = 'none';
        setSlideIndex(slideIndex + screenNewsCount);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            track.style.transition = '';
            isTransitioning.current = false;
          });
        });
      } else {
        isTransitioning.current = false;
      }
    },
    [slideIndex],
  );

  const goNextRef = useRef(goNext);
  const goPrevRef = useRef(goPrev);
  goNextRef.current = goNext;
  goPrevRef.current = goPrev;

  useEffect(() => {
    const container = carouselRef.current;
    if (!container) return;

    let lastT = 0;
    let acc = 0;
    let lastTriggerAt = 0;
    const THRESHOLD = 80;
    const WINDOW = 400;
    const COOLDOWN_MS = 700;

    const handleWheel = (e: WheelEvent) => {
      const deltaX = e.deltaX;
      const deltaY = e.deltaY;
      const isHorizontalScroll =
        Math.abs(deltaX) > Math.abs(deltaY) ||
        (Math.abs(deltaX) > 0 && Math.abs(deltaY) < 3) ||
        (Math.abs(deltaX) > Math.abs(deltaY) * 0.3 && Math.abs(deltaY) < 10);

      if (isHorizontalScroll && !e.defaultPrevented) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (!isHorizontalScroll) return;

      const now = Date.now();
      const dt = lastT ? now - lastT : 0;
      if (dt > WINDOW) acc = 0;
      lastT = now;
      acc += deltaX;
      if (Math.abs(acc) < THRESHOLD) return;
      if (Date.now() - lastTriggerAt < COOLDOWN_MS) {
        acc = 0;
        return;
      }
      lastTriggerAt = Date.now();
      acc = 0;
      if (deltaX > 0) goNextRef.current();
      else goPrevRef.current();
    };

    container.addEventListener('wheel', handleWheel, { passive: false });
    return () => container.removeEventListener('wheel', handleWheel);
  }, []);

  if (screenNewsCount === 0) {
    return null;
  }

  return (
    <section className={styles['screen-news-cover']} ref={slideInRef.ref}>
      <h2 className={styles['screen-news-title']}>媒体关注与报道</h2>

      <div className={styles['screen-news-carousel-wrapper']} ref={carouselRef}>
        <CircleArrowButton
          direction="left"
          onClick={goPrev}
          className={styles['screen-news-button-left']}
        />
        <div className={styles['screen-news-carousel']}>
          <div
            ref={trackRef}
            className={styles['screen-news-carousel-track']}
            style={{
              width: `${trackWidthPx(trackOrder.length)}px`,
              transform: `translateX(-${slideIndex * SLOT_WIDTH}px)`,
            }}
            onTransitionEnd={handleTrackTransitionEnd}
          >
            {trackOrder.map((item, index) => (
              <div
                key={`${item.id}-${index}`}
                className={styles['screen-news-carousel-item']}
                onClick={() => window.open(item.url, '_blank')}
              >
                <div className={styles['screen-news-card']}>
                  <div className={styles['screen-news-card-content']}>
                    <img src={item.pic} className={styles['screen-news-card-pic']} loading="lazy" />
                    <h3 className={styles['screen-news-card-title']}>
                      <span>{item.titleLines[0]}</span>
                      <span>{item.titleLines[1]}</span>
                    </h3>
                    <p className={styles['screen-news-card-text']}>{item.text}</p>
                  </div>
                  <div className={styles['screen-news-card-icon-wrapper']}>
                    <img
                      src={item.icon}
                      className={styles['screen-news-card-icon']}
                      style={{ height: item.iconHeight ? `${item.iconHeight}px` : '24px' }}
                      loading="lazy"
                    />
                    <img
                      src={iconRight}
                      className={styles['screen-news-card-icon-right']}
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <CircleArrowButton
          direction="right"
          onClick={goNext}
          className={styles['screen-news-button-right']}
        />
      </div>
    </section>
  );
}
